import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {environment} from '../../../../environments/environment';
import {AideFraisTypeDescriptionTranslation} from '../../../class/api/AideFraisTypeDescriptionTranslation';
import {TranslationService} from '../../services/translation.service';
import {AideFraisTypeDescription} from '../../../class/api/AideFraisTypeDescription';
import {CURRENCY_DEFAULT_OPTIONS, CURRENCY_HACK_POSITIVE_INTEGER} from "../../../core/ngx-currency-config";
import { CdkScrollable } from '@angular/cdk/scrolling';

import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import {NgxCurrency} from "@dintecom/ngx-currency";

@Component({
    selector: 'app-modal-translation-description',
    templateUrl: './modal-translation-description.component.html',
    styleUrls: ['./modal-translation-description.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, MatCheckbox, MatSelect, MatOption, NgxCurrency, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalTranslationDescriptionComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalTranslationDescriptionComponent>>(MatDialogRef);
    private translationService = inject(TranslationService);

    public aideFraisTypeDescription: AideFraisTypeDescription = null;
    public translations: AideFraisTypeDescriptionTranslation[] = [];
    public addMax = false;
    public typeMaximum = null;
    public numberMaximum = 0;

    INPUT_CURRENCY_CONFIG = {
        ...CURRENCY_HACK_POSITIVE_INTEGER,
        precision: 0,
        suffix: '',
    };

    INPUT_POURCENT_CONFIG = {
        ...CURRENCY_DEFAULT_OPTIONS,
        suffix: '',
    };

    constructor() {
        if (
            (this.data != null &&
                this.data.description != undefined &&
                this.data.description != null)
        ) {
            this.aideFraisTypeDescription = {...this.data.description};
            if(this.data.description.translations != undefined &&
                this.data.description.translations != null) {
                this.translations = [...this.data.description.translations];
            }
             else {
                environment.translations.map(locale => {
                    this.translations.push(
                        new AideFraisTypeDescriptionTranslation({locale, description: ''})
                    );
                });
            }
        }
        this.numberMaximum = (+this.aideFraisTypeDescription.numberMaximum != undefined) ? +this.aideFraisTypeDescription.numberMaximum : 0;
        this.typeMaximum = (this.aideFraisTypeDescription.typeMaximum != undefined) ? this.aideFraisTypeDescription.typeMaximum : null;
        if(this.typeMaximum !== null && this.numberMaximum) {
            this.addMax = true;
        }
    }

    public translationNotValide() {
        let response = false;
        this.translations.map((item: AideFraisTypeDescriptionTranslation) => {
            if (
                item.description == undefined ||
                item.description == null ||
                item.description == ''
            )
                {response = true;}
        });
        return response;
    }

    ngOnInit() {
    }

    public showMaxFields(event) {
        this.addMax = event.checked;
        if(!this.addMax) {
            this.typeMaximum = null;
            this.numberMaximum = 0;
        }
    }

    public adaptMontant(event) {
        if(this.typeMaximum === 'pourcent' && parseInt(event) > 100) {
            this.numberMaximum = 100;
        }
        if(this.typeMaximum === 'montant' && parseInt(event) > 999999999) {
            this.numberMaximum = 999999999;
        }
        if(this.typeMaximum === null) {
            this.numberMaximum = 0;
        }
    }

    public submit() {
        this.aideFraisTypeDescription.translations = this.translations;
        if(this.addMax && this.numberMaximum > 0) {
            this.aideFraisTypeDescription.typeMaximum = this.typeMaximum;
            this.aideFraisTypeDescription.numberMaximum = this.numberMaximum.toString();
        }
        else {
            this.aideFraisTypeDescription.typeMaximum = null;
            this.aideFraisTypeDescription.numberMaximum = '0';
        }
        this.dialogRef.close(this.aideFraisTypeDescription);
    }
}
